/**
 * A store to manage the state of sticky headers in the application taking into account the base header and a stack of multiple sticky headers.
 */
export default function useStickyHeaderStore() {
  const isHeaderHidden = useState("isBaseHeaderHidden", () => false);
  const { baseHeaderHeight } = useBaseHeaderBounding();
  const { stickyHeaderHeight } = useStickyHeaderBounding();

  return {
    isHeaderHidden,
    baseHeaderHeight,
    stickyHeaderHeight,
  };
}
